<div class="row">
  <div class="col-12">
    <div class="card">
      <div
        class="card-header spear-table-header-background d-flex justify-content-between"
      >
        <h6></h6>
      </div>
      <div class="card-body">
        <div class="col-12 primary-tab">
          <ul class="nav nav-tabs">
            <li class="nav-item" *ngFor="let tab of pageTabs">
              <button
                class="nav-link text-uppercase"
                [ngClass]="{
                  'active search-spear-background': activeTab == tab
                }"
                (click)="activeTab = tab"
              >
                {{ tab }}
              </button>
            </li>
          </ul>

          <ng-container *ngIf="activeTab == 'Program | Location'">
            <div class="search-spear-background p-2">
              <div class="row my-3">
                <div class="col-12">
                  <div
                    class="accordian-tab card-header title-space spear-table-header-background"
                  >
                    <h6 class="m-0">Program | Location</h6>
                    <div>
                      <button
                        class="btn viewBtn limos-button-background text-white btn-sm mr-2"
                        (click)="openPopup(addProgramModal,'lg')"
                      >
                        Add Program | Location
                      </button>
                      <button class="btn">
                        <em
                          (click)="generalInfo = !generalInfo"
                          class="fa fa-sort-desc"
                          [ngClass]="generalInfo ? '' : 'antirotate'"
                        ></em>
                      </button>
                    </div>
                  </div>
                  <div [ngClass]="generalInfo ? 'collapsecard' : 'expandcard'">
                    <div class="card border-0 card-scrollbar">
                      <div
                        class="card-body p-3 text-black-contrast text-sm text-dark-bold"
                        *blockUI="'program-location-list-ui'"
                      >
                        <table class="table">
                          <thead>
                            <tr>
                              <th class="border-0" scope="col">Program</th>
                              <th class="border-0" scope="col">Location</th>
                            </tr>
                          </thead>
                          <tbody *ngIf="programLocations?.length">
                            <ng-container *ngFor="let location of programLocations">
                              <tr class="bg-white">
                                <td>
                                  <a
                                    [routerLink]="['/program', location.id]"
                                    target="_blank"
                                    class="cursor-pointer primary-text font-weight-semibold"
                                    >{{ location.program_location_name }}</a
                                  >
                                </td>
                                <td>{{location.full_physical_address}} </td>
                              </tr>
                            </ng-container>
                          </tbody>
                          <tbody *ngIf="!programLocations?.length">
                            <tr class="bg-white">
                              <td colspan="2" class="text-center">Data not available</td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          class="px-0 py-0 paginationWrapper d-flex"
                          *ngIf="!(!programLocations || programLocations.length === 0)"
                        >
                          <ngb-pagination
                            [(collectionSize)]="programLocationTotal"
                            [(page)]="programLocationPage"
                            [pageSize]="programLocationLimit"
                            [maxSize]="10"
                            [boundaryLinks]="true"
                            (pageChange)="onPageChangeProgramLocations($event)"
                          >
                          </ngb-pagination>
                          <div class="selected d-flex align-items-center">
                            <select
                              (change)="onSizeChangeProgramLocations(programLocationLimit)"
                              class="custom-select table-select h-100"
                              [(ngModel)]="programLocationLimit"
                            >
                              <option [ngValue]="20">20</option>
                              <option [ngValue]="50">50</option>
                              <option [ngValue]="75">75</option>
                              <option [ngValue]="100">100</option>
                            </select>
                            <p class="mb-0 ml-2 text-nowrap">
                              Showing {{ programLocationPage * programLocationLimit - programLocationLimit + 1 }}
                              -
                              {{
                                programLocationPage * programLocationLimit > programLocationTotal
                                  ? programLocationTotal
                                  : programLocationPage * programLocationLimit
                              }}
                              of {{ programLocationTotal }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="activeTab == 'Client Contact'">
            <div class="search-spear-background p-2">
              <div class="row my-3">
                <div class="col-12">
                  <div
                    class="accordian-tab card-header title-space spear-table-header-background"
                  >
                    <h6 class="m-0">Contact Information</h6>
                    <div>
                      <button
                        class="btn viewBtn limos-button-background text-white btn-sm mr-2"
                        (click)="openPopup(addClientContact,'lg')"
                      >
                        Add Client Contact
                      </button>
                      <button class="btn">
                        <em
                          (click)="generalInfo = !generalInfo"
                          class="fa fa-sort-desc"
                          [ngClass]="generalInfo ? '' : 'antirotate'"
                        ></em>
                      </button>
                    </div>
                  </div>
                  <div [ngClass]="generalInfo ? 'collapsecard' : 'expandcard'">
                    <div class="card border-0 card-scrollbar">
                      <div
                        class="card-body p-3 text-black-contrast text-sm text-dark-bold"
                        *blockUI="'client-contacts-ui'"
                      >
                        <table class="table">
                          <thead>
                            <tr>
                              <th class="border-0" scope="col">Name</th>
                              <th class="border-0" scope="col">Role</th>
                              <th class="border-0" scope="col">Email</th>
                              <th class="border-0" scope="col">Phone</th>
                            </tr>
                          </thead>
                          <tbody *ngIf="clientContacts?.length">
                            <ng-container *ngFor="let contact of clientContacts">
                              <tr class="bg-white">
                                <td>
                                  <a
                                    [routerLink]="['/client-contact', contact.id]"
                                    target="_blank"
                                    class="cursor-pointer primary-text font-weight-semibold"
                                    >{{ contact?.full_name }}
                                    </a>
                                </td>
                                <td></td>
                                <td>{{ contact?.email }}</td>
                                <td>{{ contact?.mobile_phone }}</td>
                              </tr>
                            </ng-container>
                          </tbody>
                          <tbody *ngIf="!clientContacts?.length">
                            <tr class="bg-white">
                              <td colspan="4" class="text-center">Data not available</td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          class="px-0 py-0 paginationWrapper d-flex"
                          *ngIf="!(!clientContacts || clientContacts.length === 0)"
                        >
                          <ngb-pagination
                            [(collectionSize)]="clientContactTotal"
                            [(page)]="clientContactPage"
                            [pageSize]="clientContactLimit"
                            [maxSize]="10"
                            [boundaryLinks]="true"
                            (pageChange)="onPageChangeclients($event)"
                          >
                          </ngb-pagination>
                          <div class="selected d-flex align-items-center">
                            <select
                              (change)="onSizeChangeclients(clientContactLimit)"
                              class="custom-select table-select h-100"
                              [(ngModel)]="clientContactLimit"
                            >
                              <option [ngValue]="20">20</option>
                              <option [ngValue]="50">50</option>
                              <option [ngValue]="75">75</option>
                              <option [ngValue]="100">100</option>
                            </select>
                            <p class="mb-0 ml-2 text-nowrap">
                              Showing {{ clientContactPage * clientContactLimit - clientContactLimit + 1 }}
                              -
                              {{
                                clientContactPage * clientContactLimit > clientContactTotal
                                  ? clientContactTotal
                                  : clientContactPage * clientContactLimit
                              }}
                              of {{ clientContactTotal }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addProgramModal let-modal>
  <div class="modal-header">
    <h6>Add Program</h6>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modalService.dismissAll()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body create-client text-sm">
    <form [formGroup]="addProgramForm">
      <div class="row mb-2">
        <div class="col-12">
          <div>
            <span class="text-dark fw-500 required" for="program_name"
              >Program Name</span
            >
            <input
              type="text"
              name="program_name"
              id="program_name"
              class="form-control"
              formControlName="program_name"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="street_address"
              >Street Address</span
            >
            <input
              type="text"
              name="street_address"
              id="street_address"
              class="form-control"
              formControlName="physical_address_1"
            />
          </div>
        </div>
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="city"
              >City</span
            >
            <input
              type="text"
              name="city"
              id="city"
              class="form-control"
              formControlName="physical_city"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="state"
              >State</span
            >
            <input
              type="text"
              name="state"
              id="state"
              class="form-control"
              formControlName="physical_state"
            />
          </div>
        </div>
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="zip"
              >Zip</span
            >
            <input
              type="number"
              name="zip"
              id="zip"
              class="form-control"
              formControlName="physical_zip"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="primary_phone"
              >Primary Phone</span
            >
            <input
              type="number"
              name="primary_phone"
              id="primary_phone"
              class="form-control"
              formControlName="primary_phone"
            />
          </div>
        </div>
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="primary_email"
              >Primary Email</span
            >
            <input
              type="email"
              name="primary_email"
              id="primary_email"
              class="form-control"
              formControlName="primary_email"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="billing_email"
              >Billing Email</span
            >
            <input
              type="email"
              name="billing_email"
              id="billing_email"
              class="form-control"
              formControlName="billing_email"
            />
          </div>
        </div>
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="client_instructions"
              >Client Instructions</span
            >
            <textarea
              name="client_instructions"
              id="client_instructions"
              class="w-100 border"
              formControlName="client_instructions"
            >
          </textarea>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="invoice_instructions"
              >Invoice Instructions</span
            >
            <textarea
              type="text"
              name="invoice_instructions"
              id="invoice_instructions"
              class="form-control"
              formControlName="invoice_instructions"
            ></textarea>
          </div>
        </div>
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="general_notes"
              >General Notes</span
            >
            <textarea
              name="general_notes"
              id="general_notes"
              class="w-100 border"
              formControlName="general_notes"
            >
          </textarea>
          </div>
        </div>
      </div>

      <div class="mt-4 d-flex justify-content-end">
        <div>
          <button
            type="button"
            class="btn btn-secondary btn-sm text-white mr-1"
            (click)="addmodalService2.dismissAll()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn limos-button-background btn-sm text-white mr-1"
            (click)="addProgram()"
            [disabled]="addProgramForm.invalid || isProgramFormSubmitted"
          >
            Save
          </button>
          <button
            type="button"
            class="btn btn-info btn-sm text-white"
            (click)="addNewProgram()"
            [disabled]="addProgramForm.invalid || isProgramFormSubmitted"
          >
            Add New Program
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #addClientContact let-modal>
  <div class="modal-header">
    <h6>Add Client Contact</h6>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modalService.dismissAll()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-form text-sm">
    <form [formGroup]="addClientContactForm">
      <div class="row mb-2">
        <div class="col-12">
          <div>
            <span class="text-dark fw-500 required" for="title"
              >Title</span
            >
            <input
              type="text"
              name="title"
              id="title"
              class="form-control"
              formControlName="title"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <div>
            <span class="text-dark fw-500 required" for="first_name"
              >First Name</span
            >
            <input
              type="text"
              name="first_name"
              id="first_name"
              class="form-control"
              formControlName="first_name"
            />
          </div>
        </div>

        <div class="col-4">
          <div>
            <span class="text-dark fw-500 required" for="middle_name"
              >Middle Name</span
            >
            <input
              type="text"
              name="middle_name"
              id="middle_name"
              class="form-control"
              formControlName="middle_name"
            />
          </div>
        </div>

        <div class="col-4">
          <div>
            <span class="text-dark fw-500 required" for="last_name"
              >Last Name</span
            >
            <input
              type="text"
              name="last_name"
              id="last_name"
              class="form-control"
              formControlName="last_name"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="email"
              >Email</span
            >
            <input
              type="text"
              name="email"
              id="email"
              class="form-control"
              formControlName="email"
            />
          </div>
        </div>
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="work_phone"
              >Work Phone</span
            >
            <input
              type="text"
              name="work_phone"
              id="work_phone"
              class="form-control"
              formControlName="work_phone"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="mobile_phone"
              >Mobile Phone</span
            >
            <input
              type="text"
              name="mobile_phone"
              id="mobile_phone"
              class="form-control"
              formControlName="mobile_phone"
            />
          </div>
        </div>
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="social_security_number"
              >Social Security Number</span
            >
            <input
              type="number"
              name="social_security_number"
              id="social_security_number"
              class="form-control"
              formControlName="social_security_number"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="date_of_birth"
              >Date of Birth</span
            >
            <input
              type="text"
              name="date_of_birth"
              id="date_of_birth"
              class="form-control"
              [formCtrl]="addClientContactForm.get('dob')"
              jDate
            />
          </div>
        </div>
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="general_notes"
              >General Notes</span
            >
            <textarea
              name="general_notes"
              id="general_notes"
              class="w-100 border"
              formControlName="general_notes"
            >
          </textarea>
          </div>
        </div>
      </div>

      <div class="mt-4 d-flex justify-content-end">
        <div>
          <button
            type="button"
            class="btn btn-secondary btn-sm text-white mr-1"
            (click)="modalService.dismissAll()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn limos-button-background btn-sm text-white mr-1"
            (click)="saveClientContact()"
            [disabled]="addClientContactForm.invalid"
          >
            Save
          </button>
          <button
            type="button"
            class="btn btn-info btn-sm text-white"
            (click)="addNewClientContact()"
            [disabled]="addClientContactForm.invalid"
          >
            Add New Client Contact
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
